export default "__VITE_ASSET__gdkEKov___"